import __pb_dep_0 from "google-protobuf";

const __pbDeps = {
  "google-protobuf": __pb_dep_0,
};

const __pbModule = { exports: {} };
const exports = __pbModule.exports;
const module = __pbModule;

const require = (specifier) => {
  const resolved = __pbDeps[specifier];
  if (!resolved) {
    throw new Error(`Unsupported protobuf dependency in IM.BaseDefine_pb.js: ${specifier}`);
  }
  return resolved;
};

(function runGeneratedProtobufModule() {
  const root = globalThis;
  root.proto ??= {};
  var proto = root.proto;
  var COMPILED = false;

// source: IM.BaseDefine.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck
var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();
goog.exportSymbol('proto.IM.BaseDefine.AuthInfo', null, global);
goog.exportSymbol('proto.IM.BaseDefine.BuddyListCmdID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.CallCmdID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.ClientFileRole', null, global);
goog.exportSymbol('proto.IM.BaseDefine.ClientFileState', null, global);
goog.exportSymbol('proto.IM.BaseDefine.ClientType', null, global);
goog.exportSymbol('proto.IM.BaseDefine.ContactSessionInfo', null, global);
goog.exportSymbol('proto.IM.BaseDefine.DepartInfo', null, global);
goog.exportSymbol('proto.IM.BaseDefine.DepartmentStatusType', null, global);
goog.exportSymbol('proto.IM.BaseDefine.FileCmdID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.FileRecoveryCmdID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.FileServerError', null, global);
goog.exportSymbol('proto.IM.BaseDefine.GroupCmdID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.GroupInfo', null, global);
goog.exportSymbol('proto.IM.BaseDefine.GroupModifyType', null, global);
goog.exportSymbol('proto.IM.BaseDefine.GroupType', null, global);
goog.exportSymbol('proto.IM.BaseDefine.GroupVersionInfo', null, global);
goog.exportSymbol('proto.IM.BaseDefine.InternalCmdID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.IpAddr', null, global);
goog.exportSymbol('proto.IM.BaseDefine.KickReasonType', null, global);
goog.exportSymbol('proto.IM.BaseDefine.LoginCmdID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.MessageCmdID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.MsgInfo', null, global);
goog.exportSymbol('proto.IM.BaseDefine.MsgType', null, global);
goog.exportSymbol('proto.IM.BaseDefine.OfflineFileInfo', null, global);
goog.exportSymbol('proto.IM.BaseDefine.OnlineListType', null, global);
goog.exportSymbol('proto.IM.BaseDefine.OtherCmdID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.ProfileCmdID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.PushResult', null, global);
goog.exportSymbol('proto.IM.BaseDefine.PushShieldStatus', null, global);
goog.exportSymbol('proto.IM.BaseDefine.ResultType', null, global);
goog.exportSymbol('proto.IM.BaseDefine.ServerUserStat', null, global);
goog.exportSymbol('proto.IM.BaseDefine.ServiceID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.SessionStatusType', null, global);
goog.exportSymbol('proto.IM.BaseDefine.SessionType', null, global);
goog.exportSymbol('proto.IM.BaseDefine.ShieldStatus', null, global);
goog.exportSymbol('proto.IM.BaseDefine.SwitchServiceCmdID', null, global);
goog.exportSymbol('proto.IM.BaseDefine.UnreadInfo', null, global);
goog.exportSymbol('proto.IM.BaseDefine.UserIdentityRef', null, global);
goog.exportSymbol('proto.IM.BaseDefine.UserStat', null, global);
goog.exportSymbol('proto.IM.BaseDefine.UserStatType', null, global);
goog.exportSymbol('proto.IM.BaseDefine.UserTokenInfo', null, global);
goog.exportSymbol('proto.IM.BaseDefine.XFileType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.IpAddr = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.IpAddr, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.IpAddr.displayName = 'proto.IM.BaseDefine.IpAddr';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.UserIdentityRef = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.UserIdentityRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.UserIdentityRef.displayName = 'proto.IM.BaseDefine.UserIdentityRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.ContactSessionInfo = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.ContactSessionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.ContactSessionInfo.displayName = 'proto.IM.BaseDefine.ContactSessionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.UserStat = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.UserStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.UserStat.displayName = 'proto.IM.BaseDefine.UserStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.ServerUserStat = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.ServerUserStat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.ServerUserStat.displayName = 'proto.IM.BaseDefine.ServerUserStat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.UnreadInfo = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.UnreadInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.UnreadInfo.displayName = 'proto.IM.BaseDefine.UnreadInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.MsgInfo = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.MsgInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.MsgInfo.displayName = 'proto.IM.BaseDefine.MsgInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.GroupVersionInfo = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.GroupVersionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.GroupVersionInfo.displayName = 'proto.IM.BaseDefine.GroupVersionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.GroupInfo = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, proto.IM.BaseDefine.GroupInfo.repeatedFields_, null);
};
goog.inherits(proto.IM.BaseDefine.GroupInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.GroupInfo.displayName = 'proto.IM.BaseDefine.GroupInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.UserTokenInfo = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.UserTokenInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.UserTokenInfo.displayName = 'proto.IM.BaseDefine.UserTokenInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.PushResult = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.PushResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.PushResult.displayName = 'proto.IM.BaseDefine.PushResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.ShieldStatus = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.ShieldStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.ShieldStatus.displayName = 'proto.IM.BaseDefine.ShieldStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.OfflineFileInfo = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.OfflineFileInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.OfflineFileInfo.displayName = 'proto.IM.BaseDefine.OfflineFileInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.AuthInfo = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.AuthInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.AuthInfo.displayName = 'proto.IM.BaseDefine.AuthInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.DepartInfo = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.DepartInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.DepartInfo.displayName = 'proto.IM.BaseDefine.DepartInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.BaseDefine.PushShieldStatus = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.BaseDefine.PushShieldStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.BaseDefine.PushShieldStatus.displayName = 'proto.IM.BaseDefine.PushShieldStatus';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.IpAddr.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.IpAddr.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.IpAddr} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.IpAddr.toObject = function(includeInstance, msg) {
        var f, obj = {
            ip: jspb.Message.getFieldWithDefault(msg, 1, ""),
            port: jspb.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.IpAddr}
 */ proto.IM.BaseDefine.IpAddr.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.IpAddr;
    return proto.IM.BaseDefine.IpAddr.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.IpAddr} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.IpAddr}
 */ proto.IM.BaseDefine.IpAddr.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setIp(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setPort(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.IpAddr.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.IpAddr.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.IpAddr} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.IpAddr.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getIp();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getPort();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
};
/**
 * optional string ip = 1;
 * @return {string}
 */ proto.IM.BaseDefine.IpAddr.prototype.getIp = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.IpAddr} returns this
 */ proto.IM.BaseDefine.IpAddr.prototype.setIp = function(value) {
    return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 port = 2;
 * @return {number}
 */ proto.IM.BaseDefine.IpAddr.prototype.getPort = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.IpAddr} returns this
 */ proto.IM.BaseDefine.IpAddr.prototype.setPort = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.UserIdentityRef.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.UserIdentityRef.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.UserIdentityRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.UserIdentityRef.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            profileVersion: jspb.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.UserIdentityRef}
 */ proto.IM.BaseDefine.UserIdentityRef.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.UserIdentityRef;
    return proto.IM.BaseDefine.UserIdentityRef.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.UserIdentityRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.UserIdentityRef}
 */ proto.IM.BaseDefine.UserIdentityRef.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint64();
                msg.setProfileVersion(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.UserIdentityRef.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.UserIdentityRef.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.UserIdentityRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.UserIdentityRef.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getProfileVersion();
    if (f !== 0) {
        writer.writeUint64(2, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.UserIdentityRef.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.UserIdentityRef} returns this
 */ proto.IM.BaseDefine.UserIdentityRef.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint64 profile_version = 2;
 * @return {number}
 */ proto.IM.BaseDefine.UserIdentityRef.prototype.getProfileVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.UserIdentityRef} returns this
 */ proto.IM.BaseDefine.UserIdentityRef.prototype.setProfileVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.ContactSessionInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.ContactSessionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.ContactSessionInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            sessionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            sessionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
            sessionStatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
            updatedTime: jspb.Message.getFieldWithDefault(msg, 4, 0),
            latestMsgId: jspb.Message.getFieldWithDefault(msg, 5, 0),
            latestMsgData: msg.getLatestMsgData_asB64(),
            latestMsgType: jspb.Message.getFieldWithDefault(msg, 7, 0),
            latestMsgFromUserId: jspb.Message.getFieldWithDefault(msg, 8, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.ContactSessionInfo}
 */ proto.IM.BaseDefine.ContactSessionInfo.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.ContactSessionInfo;
    return proto.IM.BaseDefine.ContactSessionInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.ContactSessionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.ContactSessionInfo}
 */ proto.IM.BaseDefine.ContactSessionInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSessionId(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.BaseDefine.SessionType} */ reader.readEnum();
                msg.setSessionType(value);
                break;
            case 3:
                var value = /** @type {!proto.IM.BaseDefine.SessionStatusType} */ reader.readEnum();
                msg.setSessionStatus(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUpdatedTime(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLatestMsgId(value);
                break;
            case 6:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setLatestMsgData(value);
                break;
            case 7:
                var value = /** @type {!proto.IM.BaseDefine.MsgType} */ reader.readEnum();
                msg.setLatestMsgType(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLatestMsgFromUserId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.ContactSessionInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.ContactSessionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.ContactSessionInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSessionId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getSessionType();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
    f = message.getSessionStatus();
    if (f !== 0.0) {
        writer.writeEnum(3, f);
    }
    f = message.getUpdatedTime();
    if (f !== 0) {
        writer.writeUint32(4, f);
    }
    f = message.getLatestMsgId();
    if (f !== 0) {
        writer.writeUint32(5, f);
    }
    f = message.getLatestMsgData_asU8();
    if (f.length > 0) {
        writer.writeBytes(6, f);
    }
    f = message.getLatestMsgType();
    if (f !== 0.0) {
        writer.writeEnum(7, f);
    }
    f = message.getLatestMsgFromUserId();
    if (f !== 0) {
        writer.writeUint32(8, f);
    }
};
/**
 * optional uint32 session_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.getSessionId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.ContactSessionInfo} returns this
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional SessionType session_type = 2;
 * @return {!proto.IM.BaseDefine.SessionType}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.getSessionType = function() {
    return /** @type {!proto.IM.BaseDefine.SessionType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.BaseDefine.SessionType} value
 * @return {!proto.IM.BaseDefine.ContactSessionInfo} returns this
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.setSessionType = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional SessionStatusType session_status = 3;
 * @return {!proto.IM.BaseDefine.SessionStatusType}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.getSessionStatus = function() {
    return /** @type {!proto.IM.BaseDefine.SessionStatusType} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.IM.BaseDefine.SessionStatusType} value
 * @return {!proto.IM.BaseDefine.ContactSessionInfo} returns this
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.setSessionStatus = function(value) {
    return jspb.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional uint32 updated_time = 4;
 * @return {number}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.getUpdatedTime = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.ContactSessionInfo} returns this
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.setUpdatedTime = function(value) {
    return jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional uint32 latest_msg_id = 5;
 * @return {number}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.getLatestMsgId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.ContactSessionInfo} returns this
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.setLatestMsgId = function(value) {
    return jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional bytes latest_msg_data = 6;
 * @return {string}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.getLatestMsgData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 6, "");
};
/**
 * optional bytes latest_msg_data = 6;
 * This is a type-conversion wrapper around `getLatestMsgData()`
 * @return {string}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.getLatestMsgData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getLatestMsgData());
};
/**
 * optional bytes latest_msg_data = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getLatestMsgData()`
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.getLatestMsgData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getLatestMsgData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.BaseDefine.ContactSessionInfo} returns this
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.setLatestMsgData = function(value) {
    return jspb.Message.setProto3BytesField(this, 6, value);
};
/**
 * optional MsgType latest_msg_type = 7;
 * @return {!proto.IM.BaseDefine.MsgType}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.getLatestMsgType = function() {
    return /** @type {!proto.IM.BaseDefine.MsgType} */ jspb.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {!proto.IM.BaseDefine.MsgType} value
 * @return {!proto.IM.BaseDefine.ContactSessionInfo} returns this
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.setLatestMsgType = function(value) {
    return jspb.Message.setProto3EnumField(this, 7, value);
};
/**
 * optional uint32 latest_msg_from_user_id = 8;
 * @return {number}
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.getLatestMsgFromUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.ContactSessionInfo} returns this
 */ proto.IM.BaseDefine.ContactSessionInfo.prototype.setLatestMsgFromUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 8, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.UserStat.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.UserStat.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.UserStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.UserStat.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            status: jspb.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.UserStat}
 */ proto.IM.BaseDefine.UserStat.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.UserStat;
    return proto.IM.BaseDefine.UserStat.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.UserStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.UserStat}
 */ proto.IM.BaseDefine.UserStat.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.BaseDefine.UserStatType} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.UserStat.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.UserStat.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.UserStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.UserStat.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getStatus();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.UserStat.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.UserStat} returns this
 */ proto.IM.BaseDefine.UserStat.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional UserStatType status = 2;
 * @return {!proto.IM.BaseDefine.UserStatType}
 */ proto.IM.BaseDefine.UserStat.prototype.getStatus = function() {
    return /** @type {!proto.IM.BaseDefine.UserStatType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.BaseDefine.UserStatType} value
 * @return {!proto.IM.BaseDefine.UserStat} returns this
 */ proto.IM.BaseDefine.UserStat.prototype.setStatus = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.ServerUserStat.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.ServerUserStat.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.ServerUserStat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.ServerUserStat.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            status: jspb.Message.getFieldWithDefault(msg, 2, 0),
            clientType: jspb.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.ServerUserStat}
 */ proto.IM.BaseDefine.ServerUserStat.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.ServerUserStat;
    return proto.IM.BaseDefine.ServerUserStat.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.ServerUserStat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.ServerUserStat}
 */ proto.IM.BaseDefine.ServerUserStat.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.BaseDefine.UserStatType} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 3:
                var value = /** @type {!proto.IM.BaseDefine.ClientType} */ reader.readEnum();
                msg.setClientType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.ServerUserStat.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.ServerUserStat.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.ServerUserStat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.ServerUserStat.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getStatus();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
    f = message.getClientType();
    if (f !== 0.0) {
        writer.writeEnum(3, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.ServerUserStat.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.ServerUserStat} returns this
 */ proto.IM.BaseDefine.ServerUserStat.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional UserStatType status = 2;
 * @return {!proto.IM.BaseDefine.UserStatType}
 */ proto.IM.BaseDefine.ServerUserStat.prototype.getStatus = function() {
    return /** @type {!proto.IM.BaseDefine.UserStatType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.BaseDefine.UserStatType} value
 * @return {!proto.IM.BaseDefine.ServerUserStat} returns this
 */ proto.IM.BaseDefine.ServerUserStat.prototype.setStatus = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional ClientType client_type = 3;
 * @return {!proto.IM.BaseDefine.ClientType}
 */ proto.IM.BaseDefine.ServerUserStat.prototype.getClientType = function() {
    return /** @type {!proto.IM.BaseDefine.ClientType} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.IM.BaseDefine.ClientType} value
 * @return {!proto.IM.BaseDefine.ServerUserStat} returns this
 */ proto.IM.BaseDefine.ServerUserStat.prototype.setClientType = function(value) {
    return jspb.Message.setProto3EnumField(this, 3, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.UnreadInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.UnreadInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.UnreadInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.UnreadInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            sessionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            sessionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
            unreadCnt: jspb.Message.getFieldWithDefault(msg, 3, 0),
            latestMsgId: jspb.Message.getFieldWithDefault(msg, 4, 0),
            latestMsgData: msg.getLatestMsgData_asB64(),
            latestMsgType: jspb.Message.getFieldWithDefault(msg, 6, 0),
            latestMsgFromUserId: jspb.Message.getFieldWithDefault(msg, 7, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.UnreadInfo}
 */ proto.IM.BaseDefine.UnreadInfo.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.UnreadInfo;
    return proto.IM.BaseDefine.UnreadInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.UnreadInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.UnreadInfo}
 */ proto.IM.BaseDefine.UnreadInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSessionId(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.BaseDefine.SessionType} */ reader.readEnum();
                msg.setSessionType(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUnreadCnt(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLatestMsgId(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setLatestMsgData(value);
                break;
            case 6:
                var value = /** @type {!proto.IM.BaseDefine.MsgType} */ reader.readEnum();
                msg.setLatestMsgType(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLatestMsgFromUserId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.UnreadInfo.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.UnreadInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.UnreadInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.UnreadInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSessionId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getSessionType();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
    f = message.getUnreadCnt();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
    f = message.getLatestMsgId();
    if (f !== 0) {
        writer.writeUint32(4, f);
    }
    f = message.getLatestMsgData_asU8();
    if (f.length > 0) {
        writer.writeBytes(5, f);
    }
    f = message.getLatestMsgType();
    if (f !== 0.0) {
        writer.writeEnum(6, f);
    }
    f = message.getLatestMsgFromUserId();
    if (f !== 0) {
        writer.writeUint32(7, f);
    }
};
/**
 * optional uint32 session_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.UnreadInfo.prototype.getSessionId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.UnreadInfo} returns this
 */ proto.IM.BaseDefine.UnreadInfo.prototype.setSessionId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional SessionType session_type = 2;
 * @return {!proto.IM.BaseDefine.SessionType}
 */ proto.IM.BaseDefine.UnreadInfo.prototype.getSessionType = function() {
    return /** @type {!proto.IM.BaseDefine.SessionType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.BaseDefine.SessionType} value
 * @return {!proto.IM.BaseDefine.UnreadInfo} returns this
 */ proto.IM.BaseDefine.UnreadInfo.prototype.setSessionType = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional uint32 unread_cnt = 3;
 * @return {number}
 */ proto.IM.BaseDefine.UnreadInfo.prototype.getUnreadCnt = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.UnreadInfo} returns this
 */ proto.IM.BaseDefine.UnreadInfo.prototype.setUnreadCnt = function(value) {
    return jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional uint32 latest_msg_id = 4;
 * @return {number}
 */ proto.IM.BaseDefine.UnreadInfo.prototype.getLatestMsgId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.UnreadInfo} returns this
 */ proto.IM.BaseDefine.UnreadInfo.prototype.setLatestMsgId = function(value) {
    return jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional bytes latest_msg_data = 5;
 * @return {string}
 */ proto.IM.BaseDefine.UnreadInfo.prototype.getLatestMsgData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes latest_msg_data = 5;
 * This is a type-conversion wrapper around `getLatestMsgData()`
 * @return {string}
 */ proto.IM.BaseDefine.UnreadInfo.prototype.getLatestMsgData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getLatestMsgData());
};
/**
 * optional bytes latest_msg_data = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getLatestMsgData()`
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.UnreadInfo.prototype.getLatestMsgData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getLatestMsgData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.BaseDefine.UnreadInfo} returns this
 */ proto.IM.BaseDefine.UnreadInfo.prototype.setLatestMsgData = function(value) {
    return jspb.Message.setProto3BytesField(this, 5, value);
};
/**
 * optional MsgType latest_msg_type = 6;
 * @return {!proto.IM.BaseDefine.MsgType}
 */ proto.IM.BaseDefine.UnreadInfo.prototype.getLatestMsgType = function() {
    return /** @type {!proto.IM.BaseDefine.MsgType} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.IM.BaseDefine.MsgType} value
 * @return {!proto.IM.BaseDefine.UnreadInfo} returns this
 */ proto.IM.BaseDefine.UnreadInfo.prototype.setLatestMsgType = function(value) {
    return jspb.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional uint32 latest_msg_from_user_id = 7;
 * @return {number}
 */ proto.IM.BaseDefine.UnreadInfo.prototype.getLatestMsgFromUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.UnreadInfo} returns this
 */ proto.IM.BaseDefine.UnreadInfo.prototype.setLatestMsgFromUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 7, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.MsgInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.MsgInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.MsgInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.MsgInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            msgId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            fromSessionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
            createTime: jspb.Message.getFieldWithDefault(msg, 3, 0),
            msgType: jspb.Message.getFieldWithDefault(msg, 4, 0),
            msgData: msg.getMsgData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.MsgInfo}
 */ proto.IM.BaseDefine.MsgInfo.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.MsgInfo;
    return proto.IM.BaseDefine.MsgInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.MsgInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.MsgInfo}
 */ proto.IM.BaseDefine.MsgInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMsgId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setFromSessionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setCreateTime(value);
                break;
            case 4:
                var value = /** @type {!proto.IM.BaseDefine.MsgType} */ reader.readEnum();
                msg.setMsgType(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMsgData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.MsgInfo.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.MsgInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.MsgInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.MsgInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMsgId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getFromSessionId();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = message.getCreateTime();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
    f = message.getMsgType();
    if (f !== 0.0) {
        writer.writeEnum(4, f);
    }
    f = message.getMsgData_asU8();
    if (f.length > 0) {
        writer.writeBytes(5, f);
    }
};
/**
 * optional uint32 msg_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.MsgInfo.prototype.getMsgId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.MsgInfo} returns this
 */ proto.IM.BaseDefine.MsgInfo.prototype.setMsgId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 from_session_id = 2;
 * @return {number}
 */ proto.IM.BaseDefine.MsgInfo.prototype.getFromSessionId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.MsgInfo} returns this
 */ proto.IM.BaseDefine.MsgInfo.prototype.setFromSessionId = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint32 create_time = 3;
 * @return {number}
 */ proto.IM.BaseDefine.MsgInfo.prototype.getCreateTime = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.MsgInfo} returns this
 */ proto.IM.BaseDefine.MsgInfo.prototype.setCreateTime = function(value) {
    return jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional MsgType msg_type = 4;
 * @return {!proto.IM.BaseDefine.MsgType}
 */ proto.IM.BaseDefine.MsgInfo.prototype.getMsgType = function() {
    return /** @type {!proto.IM.BaseDefine.MsgType} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.IM.BaseDefine.MsgType} value
 * @return {!proto.IM.BaseDefine.MsgInfo} returns this
 */ proto.IM.BaseDefine.MsgInfo.prototype.setMsgType = function(value) {
    return jspb.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional bytes msg_data = 5;
 * @return {string}
 */ proto.IM.BaseDefine.MsgInfo.prototype.getMsgData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes msg_data = 5;
 * This is a type-conversion wrapper around `getMsgData()`
 * @return {string}
 */ proto.IM.BaseDefine.MsgInfo.prototype.getMsgData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getMsgData());
};
/**
 * optional bytes msg_data = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMsgData()`
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.MsgInfo.prototype.getMsgData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getMsgData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.BaseDefine.MsgInfo} returns this
 */ proto.IM.BaseDefine.MsgInfo.prototype.setMsgData = function(value) {
    return jspb.Message.setProto3BytesField(this, 5, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.GroupVersionInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.GroupVersionInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.GroupVersionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.GroupVersionInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            groupId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            version: jspb.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.GroupVersionInfo}
 */ proto.IM.BaseDefine.GroupVersionInfo.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.GroupVersionInfo;
    return proto.IM.BaseDefine.GroupVersionInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.GroupVersionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.GroupVersionInfo}
 */ proto.IM.BaseDefine.GroupVersionInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGroupId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setVersion(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.GroupVersionInfo.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.GroupVersionInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.GroupVersionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.GroupVersionInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getGroupId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getVersion();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
};
/**
 * optional uint32 group_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.GroupVersionInfo.prototype.getGroupId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.GroupVersionInfo} returns this
 */ proto.IM.BaseDefine.GroupVersionInfo.prototype.setGroupId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 version = 2;
 * @return {number}
 */ proto.IM.BaseDefine.GroupVersionInfo.prototype.getVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.GroupVersionInfo} returns this
 */ proto.IM.BaseDefine.GroupVersionInfo.prototype.setVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.IM.BaseDefine.GroupInfo.repeatedFields_ = [
    8
];
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.GroupInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.GroupInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.GroupInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.GroupInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            groupId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            version: jspb.Message.getFieldWithDefault(msg, 2, 0),
            groupName: jspb.Message.getFieldWithDefault(msg, 3, ""),
            groupAvatar: jspb.Message.getFieldWithDefault(msg, 4, ""),
            groupCreatorId: jspb.Message.getFieldWithDefault(msg, 5, 0),
            groupType: jspb.Message.getFieldWithDefault(msg, 6, 0),
            shieldStatus: jspb.Message.getFieldWithDefault(msg, 7, 0),
            groupMemberListList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.GroupInfo}
 */ proto.IM.BaseDefine.GroupInfo.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.GroupInfo;
    return proto.IM.BaseDefine.GroupInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.GroupInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.GroupInfo}
 */ proto.IM.BaseDefine.GroupInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGroupId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setVersion(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setGroupName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setGroupAvatar(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGroupCreatorId(value);
                break;
            case 6:
                var value = /** @type {!proto.IM.BaseDefine.GroupType} */ reader.readEnum();
                msg.setGroupType(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readUint32();
                msg.setShieldStatus(value);
                break;
            case 8:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++){
                    msg.addGroupMemberList(values[i]);
                }
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.GroupInfo.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.GroupInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.GroupInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.GroupInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getGroupId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getVersion();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = message.getGroupName();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getGroupAvatar();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
    f = message.getGroupCreatorId();
    if (f !== 0) {
        writer.writeUint32(5, f);
    }
    f = message.getGroupType();
    if (f !== 0.0) {
        writer.writeEnum(6, f);
    }
    f = message.getShieldStatus();
    if (f !== 0) {
        writer.writeUint32(7, f);
    }
    f = message.getGroupMemberListList();
    if (f.length > 0) {
        writer.writePackedUint32(8, f);
    }
};
/**
 * optional uint32 group_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.GroupInfo.prototype.getGroupId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.GroupInfo} returns this
 */ proto.IM.BaseDefine.GroupInfo.prototype.setGroupId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 version = 2;
 * @return {number}
 */ proto.IM.BaseDefine.GroupInfo.prototype.getVersion = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.GroupInfo} returns this
 */ proto.IM.BaseDefine.GroupInfo.prototype.setVersion = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string group_name = 3;
 * @return {string}
 */ proto.IM.BaseDefine.GroupInfo.prototype.getGroupName = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.GroupInfo} returns this
 */ proto.IM.BaseDefine.GroupInfo.prototype.setGroupName = function(value) {
    return jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string group_avatar = 4;
 * @return {string}
 */ proto.IM.BaseDefine.GroupInfo.prototype.getGroupAvatar = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.GroupInfo} returns this
 */ proto.IM.BaseDefine.GroupInfo.prototype.setGroupAvatar = function(value) {
    return jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional uint32 group_creator_id = 5;
 * @return {number}
 */ proto.IM.BaseDefine.GroupInfo.prototype.getGroupCreatorId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.GroupInfo} returns this
 */ proto.IM.BaseDefine.GroupInfo.prototype.setGroupCreatorId = function(value) {
    return jspb.Message.setProto3IntField(this, 5, value);
};
/**
 * optional GroupType group_type = 6;
 * @return {!proto.IM.BaseDefine.GroupType}
 */ proto.IM.BaseDefine.GroupInfo.prototype.getGroupType = function() {
    return /** @type {!proto.IM.BaseDefine.GroupType} */ jspb.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.IM.BaseDefine.GroupType} value
 * @return {!proto.IM.BaseDefine.GroupInfo} returns this
 */ proto.IM.BaseDefine.GroupInfo.prototype.setGroupType = function(value) {
    return jspb.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional uint32 shield_status = 7;
 * @return {number}
 */ proto.IM.BaseDefine.GroupInfo.prototype.getShieldStatus = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.GroupInfo} returns this
 */ proto.IM.BaseDefine.GroupInfo.prototype.setShieldStatus = function(value) {
    return jspb.Message.setProto3IntField(this, 7, value);
};
/**
 * repeated uint32 group_member_list = 8;
 * @return {!Array<number>}
 */ proto.IM.BaseDefine.GroupInfo.prototype.getGroupMemberListList = function() {
    return /** @type {!Array<number>} */ jspb.Message.getRepeatedField(this, 8);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.IM.BaseDefine.GroupInfo} returns this
 */ proto.IM.BaseDefine.GroupInfo.prototype.setGroupMemberListList = function(value) {
    return jspb.Message.setField(this, 8, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.IM.BaseDefine.GroupInfo} returns this
 */ proto.IM.BaseDefine.GroupInfo.prototype.addGroupMemberList = function(value, opt_index) {
    return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.IM.BaseDefine.GroupInfo} returns this
 */ proto.IM.BaseDefine.GroupInfo.prototype.clearGroupMemberListList = function() {
    return this.setGroupMemberListList([]);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.UserTokenInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.UserTokenInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.UserTokenInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            userType: jspb.Message.getFieldWithDefault(msg, 2, 0),
            token: jspb.Message.getFieldWithDefault(msg, 3, ""),
            pushCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
            pushType: jspb.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.UserTokenInfo}
 */ proto.IM.BaseDefine.UserTokenInfo.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.UserTokenInfo;
    return proto.IM.BaseDefine.UserTokenInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.UserTokenInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.UserTokenInfo}
 */ proto.IM.BaseDefine.UserTokenInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {!proto.IM.BaseDefine.ClientType} */ reader.readEnum();
                msg.setUserType(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setToken(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setPushCount(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setPushType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.UserTokenInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.UserTokenInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.UserTokenInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getUserType();
    if (f !== 0.0) {
        writer.writeEnum(2, f);
    }
    f = message.getToken();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getPushCount();
    if (f !== 0) {
        writer.writeUint32(4, f);
    }
    f = message.getPushType();
    if (f !== 0) {
        writer.writeUint32(5, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.UserTokenInfo} returns this
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional ClientType user_type = 2;
 * @return {!proto.IM.BaseDefine.ClientType}
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.getUserType = function() {
    return /** @type {!proto.IM.BaseDefine.ClientType} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.IM.BaseDefine.ClientType} value
 * @return {!proto.IM.BaseDefine.UserTokenInfo} returns this
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.setUserType = function(value) {
    return jspb.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string token = 3;
 * @return {string}
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.getToken = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.UserTokenInfo} returns this
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.setToken = function(value) {
    return jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional uint32 push_count = 4;
 * @return {number}
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.getPushCount = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.UserTokenInfo} returns this
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.setPushCount = function(value) {
    return jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional uint32 push_type = 5;
 * @return {number}
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.getPushType = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.UserTokenInfo} returns this
 */ proto.IM.BaseDefine.UserTokenInfo.prototype.setPushType = function(value) {
    return jspb.Message.setProto3IntField(this, 5, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.PushResult.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.PushResult.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.PushResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.PushResult.toObject = function(includeInstance, msg) {
        var f, obj = {
            userToken: jspb.Message.getFieldWithDefault(msg, 1, ""),
            resultCode: jspb.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.PushResult}
 */ proto.IM.BaseDefine.PushResult.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.PushResult;
    return proto.IM.BaseDefine.PushResult.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.PushResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.PushResult}
 */ proto.IM.BaseDefine.PushResult.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setUserToken(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setResultCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.PushResult.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.PushResult.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.PushResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.PushResult.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserToken();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getResultCode();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
};
/**
 * optional string user_token = 1;
 * @return {string}
 */ proto.IM.BaseDefine.PushResult.prototype.getUserToken = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.PushResult} returns this
 */ proto.IM.BaseDefine.PushResult.prototype.setUserToken = function(value) {
    return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 result_code = 2;
 * @return {number}
 */ proto.IM.BaseDefine.PushResult.prototype.getResultCode = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.PushResult} returns this
 */ proto.IM.BaseDefine.PushResult.prototype.setResultCode = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.ShieldStatus.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.ShieldStatus.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.ShieldStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.ShieldStatus.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            groupId: jspb.Message.getFieldWithDefault(msg, 2, 0),
            shieldStatus: jspb.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.ShieldStatus}
 */ proto.IM.BaseDefine.ShieldStatus.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.ShieldStatus;
    return proto.IM.BaseDefine.ShieldStatus.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.ShieldStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.ShieldStatus}
 */ proto.IM.BaseDefine.ShieldStatus.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGroupId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setShieldStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.ShieldStatus.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.ShieldStatus.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.ShieldStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.ShieldStatus.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getGroupId();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = message.getShieldStatus();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.ShieldStatus.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.ShieldStatus} returns this
 */ proto.IM.BaseDefine.ShieldStatus.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 group_id = 2;
 * @return {number}
 */ proto.IM.BaseDefine.ShieldStatus.prototype.getGroupId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.ShieldStatus} returns this
 */ proto.IM.BaseDefine.ShieldStatus.prototype.setGroupId = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint32 shield_status = 3;
 * @return {number}
 */ proto.IM.BaseDefine.ShieldStatus.prototype.getShieldStatus = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.ShieldStatus} returns this
 */ proto.IM.BaseDefine.ShieldStatus.prototype.setShieldStatus = function(value) {
    return jspb.Message.setProto3IntField(this, 3, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.OfflineFileInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.OfflineFileInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.OfflineFileInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.OfflineFileInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            fromUserId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            taskId: jspb.Message.getFieldWithDefault(msg, 2, ""),
            fileName: jspb.Message.getFieldWithDefault(msg, 3, ""),
            fileSize: jspb.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.OfflineFileInfo}
 */ proto.IM.BaseDefine.OfflineFileInfo.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.OfflineFileInfo;
    return proto.IM.BaseDefine.OfflineFileInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.OfflineFileInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.OfflineFileInfo}
 */ proto.IM.BaseDefine.OfflineFileInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setFromUserId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setTaskId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setFileSize(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.OfflineFileInfo.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.OfflineFileInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.OfflineFileInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.OfflineFileInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getFromUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getTaskId();
    if (f.length > 0) {
        writer.writeString(2, f);
    }
    f = message.getFileName();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getFileSize();
    if (f !== 0) {
        writer.writeUint32(4, f);
    }
};
/**
 * optional uint32 from_user_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.OfflineFileInfo.prototype.getFromUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.OfflineFileInfo} returns this
 */ proto.IM.BaseDefine.OfflineFileInfo.prototype.setFromUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string task_id = 2;
 * @return {string}
 */ proto.IM.BaseDefine.OfflineFileInfo.prototype.getTaskId = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.OfflineFileInfo} returns this
 */ proto.IM.BaseDefine.OfflineFileInfo.prototype.setTaskId = function(value) {
    return jspb.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string file_name = 3;
 * @return {string}
 */ proto.IM.BaseDefine.OfflineFileInfo.prototype.getFileName = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.OfflineFileInfo} returns this
 */ proto.IM.BaseDefine.OfflineFileInfo.prototype.setFileName = function(value) {
    return jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional uint32 file_size = 4;
 * @return {number}
 */ proto.IM.BaseDefine.OfflineFileInfo.prototype.getFileSize = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.OfflineFileInfo} returns this
 */ proto.IM.BaseDefine.OfflineFileInfo.prototype.setFileSize = function(value) {
    return jspb.Message.setProto3IntField(this, 4, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.AuthInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.AuthInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.AuthInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.AuthInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            appKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
            userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
            allowdUserIds: jspb.Message.getFieldWithDefault(msg, 3, ""),
            allowdGroupIds: jspb.Message.getFieldWithDefault(msg, 4, ""),
            authInterfaces: jspb.Message.getFieldWithDefault(msg, 5, ""),
            authIps: jspb.Message.getFieldWithDefault(msg, 6, "")
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.AuthInfo}
 */ proto.IM.BaseDefine.AuthInfo.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.AuthInfo;
    return proto.IM.BaseDefine.AuthInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.AuthInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.AuthInfo}
 */ proto.IM.BaseDefine.AuthInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppKey(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAllowdUserIds(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setAllowdGroupIds(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setAuthInterfaces(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setAuthIps(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.AuthInfo.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.AuthInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.AuthInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.AuthInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppKey();
    if (f.length > 0) {
        writer.writeString(1, f);
    }
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = message.getAllowdUserIds();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getAllowdGroupIds();
    if (f.length > 0) {
        writer.writeString(4, f);
    }
    f = message.getAuthInterfaces();
    if (f.length > 0) {
        writer.writeString(5, f);
    }
    f = message.getAuthIps();
    if (f.length > 0) {
        writer.writeString(6, f);
    }
};
/**
 * optional string app_key = 1;
 * @return {string}
 */ proto.IM.BaseDefine.AuthInfo.prototype.getAppKey = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.AuthInfo} returns this
 */ proto.IM.BaseDefine.AuthInfo.prototype.setAppKey = function(value) {
    return jspb.Message.setProto3StringField(this, 1, value);
};
/**
 * optional uint32 user_id = 2;
 * @return {number}
 */ proto.IM.BaseDefine.AuthInfo.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.AuthInfo} returns this
 */ proto.IM.BaseDefine.AuthInfo.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string allowd_user_ids = 3;
 * @return {string}
 */ proto.IM.BaseDefine.AuthInfo.prototype.getAllowdUserIds = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.AuthInfo} returns this
 */ proto.IM.BaseDefine.AuthInfo.prototype.setAllowdUserIds = function(value) {
    return jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string allowd_group_ids = 4;
 * @return {string}
 */ proto.IM.BaseDefine.AuthInfo.prototype.getAllowdGroupIds = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.AuthInfo} returns this
 */ proto.IM.BaseDefine.AuthInfo.prototype.setAllowdGroupIds = function(value) {
    return jspb.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string auth_interfaces = 5;
 * @return {string}
 */ proto.IM.BaseDefine.AuthInfo.prototype.getAuthInterfaces = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.AuthInfo} returns this
 */ proto.IM.BaseDefine.AuthInfo.prototype.setAuthInterfaces = function(value) {
    return jspb.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string auth_ips = 6;
 * @return {string}
 */ proto.IM.BaseDefine.AuthInfo.prototype.getAuthIps = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.AuthInfo} returns this
 */ proto.IM.BaseDefine.AuthInfo.prototype.setAuthIps = function(value) {
    return jspb.Message.setProto3StringField(this, 6, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.DepartInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.DepartInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.DepartInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.DepartInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            deptId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            priority: jspb.Message.getFieldWithDefault(msg, 2, 0),
            deptName: jspb.Message.getFieldWithDefault(msg, 3, ""),
            parentDeptId: jspb.Message.getFieldWithDefault(msg, 4, 0),
            deptStatus: jspb.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.DepartInfo}
 */ proto.IM.BaseDefine.DepartInfo.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.DepartInfo;
    return proto.IM.BaseDefine.DepartInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.DepartInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.DepartInfo}
 */ proto.IM.BaseDefine.DepartInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDeptId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setPriority(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDeptName(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setParentDeptId(value);
                break;
            case 5:
                var value = /** @type {!proto.IM.BaseDefine.DepartmentStatusType} */ reader.readEnum();
                msg.setDeptStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.DepartInfo.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.DepartInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.DepartInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.DepartInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDeptId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getPriority();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
    f = message.getDeptName();
    if (f.length > 0) {
        writer.writeString(3, f);
    }
    f = message.getParentDeptId();
    if (f !== 0) {
        writer.writeUint32(4, f);
    }
    f = message.getDeptStatus();
    if (f !== 0.0) {
        writer.writeEnum(5, f);
    }
};
/**
 * optional uint32 dept_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.DepartInfo.prototype.getDeptId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.DepartInfo} returns this
 */ proto.IM.BaseDefine.DepartInfo.prototype.setDeptId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 priority = 2;
 * @return {number}
 */ proto.IM.BaseDefine.DepartInfo.prototype.getPriority = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.DepartInfo} returns this
 */ proto.IM.BaseDefine.DepartInfo.prototype.setPriority = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string dept_name = 3;
 * @return {string}
 */ proto.IM.BaseDefine.DepartInfo.prototype.getDeptName = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.IM.BaseDefine.DepartInfo} returns this
 */ proto.IM.BaseDefine.DepartInfo.prototype.setDeptName = function(value) {
    return jspb.Message.setProto3StringField(this, 3, value);
};
/**
 * optional uint32 parent_dept_id = 4;
 * @return {number}
 */ proto.IM.BaseDefine.DepartInfo.prototype.getParentDeptId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.DepartInfo} returns this
 */ proto.IM.BaseDefine.DepartInfo.prototype.setParentDeptId = function(value) {
    return jspb.Message.setProto3IntField(this, 4, value);
};
/**
 * optional DepartmentStatusType dept_status = 5;
 * @return {!proto.IM.BaseDefine.DepartmentStatusType}
 */ proto.IM.BaseDefine.DepartInfo.prototype.getDeptStatus = function() {
    return /** @type {!proto.IM.BaseDefine.DepartmentStatusType} */ jspb.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.IM.BaseDefine.DepartmentStatusType} value
 * @return {!proto.IM.BaseDefine.DepartInfo} returns this
 */ proto.IM.BaseDefine.DepartInfo.prototype.setDeptStatus = function(value) {
    return jspb.Message.setProto3EnumField(this, 5, value);
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.BaseDefine.PushShieldStatus.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.BaseDefine.PushShieldStatus.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.BaseDefine.PushShieldStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.PushShieldStatus.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
            shieldStatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.BaseDefine.PushShieldStatus}
 */ proto.IM.BaseDefine.PushShieldStatus.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.BaseDefine.PushShieldStatus;
    return proto.IM.BaseDefine.PushShieldStatus.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.BaseDefine.PushShieldStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.BaseDefine.PushShieldStatus}
 */ proto.IM.BaseDefine.PushShieldStatus.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setShieldStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.BaseDefine.PushShieldStatus.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.BaseDefine.PushShieldStatus.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.BaseDefine.PushShieldStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.BaseDefine.PushShieldStatus.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f !== 0) {
        writer.writeUint32(1, f);
    }
    f = message.getShieldStatus();
    if (f !== 0) {
        writer.writeUint32(2, f);
    }
};
/**
 * optional uint32 user_id = 1;
 * @return {number}
 */ proto.IM.BaseDefine.PushShieldStatus.prototype.getUserId = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.PushShieldStatus} returns this
 */ proto.IM.BaseDefine.PushShieldStatus.prototype.setUserId = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint32 shield_status = 2;
 * @return {number}
 */ proto.IM.BaseDefine.PushShieldStatus.prototype.getShieldStatus = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.BaseDefine.PushShieldStatus} returns this
 */ proto.IM.BaseDefine.PushShieldStatus.prototype.setShieldStatus = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.ServiceID = {
    SID_NONE: 0,
    SID_LOGIN: 1,
    SID_BUDDY_LIST: 2,
    SID_MSG: 3,
    SID_GROUP: 4,
    SID_FILE: 5,
    SID_SWITCH_SERVICE: 6,
    SID_OTHER: 7,
    SID_INTERNAL: 8,
    SID_PROFILE: 9,
    SID_CALL: 10
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.InternalCmdID = {
    CID_INTERNAL_NONE: 0,
    CID_INTERNAL_SYNC_AUTH_INFO_REQ: 2049,
    CID_INTERNAL_SYNC_AUTH_INFO_RSP: 2050,
    CID_INTERNAL_USER_ID_BY_NICK_NAME_REQ: 2051,
    CID_INTERNAL_USER_ID_BY_NICK_NAME_RSP: 2052
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.LoginCmdID = {
    CID_LOGIN_NONE: 0,
    CID_LOGIN_REQ_MSGSERVER: 257,
    CID_LOGIN_RES_MSGSERVER: 258,
    CID_LOGIN_REQ_USERLOGIN: 259,
    CID_LOGIN_RES_USERLOGIN: 260,
    CID_LOGIN_REQ_LOGINOUT: 261,
    CID_LOGIN_RES_LOGINOUT: 262,
    CID_LOGIN_KICK_USER: 263,
    CID_LOGIN_REQ_DEVICETOKEN: 264,
    CID_LOGIN_RES_DEVICETOKEN: 265,
    CID_LOGIN_REQ_KICKPCCLIENT: 266,
    CID_LOGIN_RES_KICKPCCLIENT: 267,
    CID_LOGIN_REQ_PUSH_SHIELD: 268,
    CID_LOGIN_RES_PUSH_SHIELD: 269,
    CID_LOGIN_REQ_QUERY_PUSH_SHIELD: 270,
    CID_LOGIN_RES_QUERY_PUSH_SHIELD: 271
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.BuddyListCmdID = {
    CID_BUDDY_LIST_NONE: 0,
    CID_BUDDY_LIST_RECENT_CONTACT_SESSION_REQUEST: 513,
    CID_BUDDY_LIST_RECENT_CONTACT_SESSION_RESPONSE: 514,
    CID_BUDDY_LIST_STATUS_NOTIFY: 515,
    CID_BUDDY_LIST_REMOVE_SESSION_REQ: 518,
    CID_BUDDY_LIST_REMOVE_SESSION_RES: 519,
    CID_BUDDY_LIST_USERS_STATUS_REQUEST: 522,
    CID_BUDDY_LIST_USERS_STATUS_RESPONSE: 523,
    CID_BUDDY_LIST_PC_LOGIN_STATUS_NOTIFY: 526,
    CID_BUDDY_LIST_REMOVE_SESSION_NOTIFY: 527,
    CID_BUDDY_LIST_DEPARTMENT_REQUEST: 528,
    CID_BUDDY_LIST_DEPARTMENT_RESPONSE: 529
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.ProfileCmdID = {
    CID_PROFILE_NONE: 0,
    CID_PROFILE_SYNC_REQ: 2305,
    CID_PROFILE_SYNC_RSP: 2306,
    CID_PROFILE_CHANGED_NOTIFY: 2307,
    CID_PROFILE_SERVER_CHANGED_NOTIFY: 2308
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.CallCmdID = {
    CID_CALL_NONE: 0,
    CID_CALL_PROJECTION_REQ: 2561,
    CID_CALL_PROJECTION_RSP: 2562
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.MessageCmdID = {
    CID_MSG_NONE: 0,
    CID_MSG_DATA: 769,
    CID_MSG_DATA_ACK: 770,
    CID_MSG_READ_ACK: 771,
    CID_MSG_READ_NOTIFY: 772,
    CID_MSG_TIME_REQUEST: 773,
    CID_MSG_TIME_RESPONSE: 774,
    CID_MSG_UNREAD_CNT_REQUEST: 775,
    CID_MSG_UNREAD_CNT_RESPONSE: 776,
    CID_MSG_LIST_REQUEST: 777,
    CID_MSG_LIST_RESPONSE: 778,
    CID_MSG_GET_LATEST_MSG_ID_REQ: 779,
    CID_MSG_GET_LATEST_MSG_ID_RSP: 780,
    CID_MSG_GET_BY_MSG_ID_REQ: 781,
    CID_MSG_GET_BY_MSG_ID_RES: 782
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.GroupCmdID = {
    CID_GROUP_NONE: 0,
    CID_GROUP_NORMAL_LIST_REQUEST: 1025,
    CID_GROUP_NORMAL_LIST_RESPONSE: 1026,
    CID_GROUP_INFO_REQUEST: 1027,
    CID_GROUP_INFO_RESPONSE: 1028,
    CID_GROUP_CREATE_REQUEST: 1029,
    CID_GROUP_CREATE_RESPONSE: 1030,
    CID_GROUP_CHANGE_MEMBER_REQUEST: 1031,
    CID_GROUP_CHANGE_MEMBER_RESPONSE: 1032,
    CID_GROUP_SHIELD_GROUP_REQUEST: 1033,
    CID_GROUP_SHIELD_GROUP_RESPONSE: 1034,
    CID_GROUP_CHANGE_MEMBER_NOTIFY: 1035
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.FileCmdID = {
    CID_FILE_NONE: 0,
    CID_FILE_LOGIN_REQ: 1281,
    CID_FILE_LOGIN_RES: 1282,
    CID_FILE_STATE: 1283,
    CID_FILE_PULL_DATA_REQ: 1284,
    CID_FILE_PULL_DATA_RSP: 1285,
    CID_FILE_REQUEST: 1286,
    CID_FILE_RESPONSE: 1287,
    CID_FILE_NOTIFY: 1288,
    CID_FILE_HAS_OFFLINE_REQ: 1289,
    CID_FILE_HAS_OFFLINE_RES: 1290,
    CID_FILE_ADD_OFFLINE_REQ: 1291,
    CID_FILE_DEL_OFFLINE_REQ: 1292,
    CID_FILE_ADD_OFFLINE_RES: 1293,
    CID_FILE_DEL_OFFLINE_RES: 1294
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.FileRecoveryCmdID = {
    CID_FILE_RECOVERY_NONE: 0,
    CID_FILE_RECOVERY_OFFER_REQ: 1297,
    CID_FILE_RECOVERY_OFFER_RSP: 1298,
    CID_FILE_RECOVERY_SNAPSHOT_REQ: 1299,
    CID_FILE_RECOVERY_SNAPSHOT_RSP: 1300,
    CID_FILE_RECOVERY_CLAIM_REQ: 1301,
    CID_FILE_RECOVERY_CLAIM_RSP: 1302,
    CID_FILE_RECOVERY_TRANSITION_REQ: 1303,
    CID_FILE_RECOVERY_TRANSITION_RSP: 1304,
    CID_FILE_RECOVERY_TICKET_REQ: 1305,
    CID_FILE_RECOVERY_TICKET_RSP: 1306,
    CID_FILE_RECOVERY_CONSUME_REQ: 1307,
    CID_FILE_RECOVERY_CONSUME_RSP: 1308,
    CID_FILE_RECOVERY_LEASE_RENEW_REQ: 1309,
    CID_FILE_RECOVERY_LEASE_RENEW_RSP: 1310
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.SwitchServiceCmdID = {
    CID_SWITCH_NONE: 0,
    CID_SWITCH_P2P_CMD: 1537
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.OtherCmdID = {
    CID_OTHER_NONE: 0,
    CID_OTHER_HEARTBEAT: 1793,
    CID_OTHER_STOP_RECV_PACKET: 1794,
    CID_OTHER_VALIDATE_REQ: 1795,
    CID_OTHER_VALIDATE_RSP: 1796,
    CID_OTHER_GET_DEVICE_TOKEN_REQ: 1797,
    CID_OTHER_GET_DEVICE_TOKEN_RSP: 1798,
    CID_OTHER_ROLE_SET: 1799,
    CID_OTHER_ONLINE_USER_INFO: 1800,
    CID_OTHER_MSG_SERV_INFO: 1801,
    CID_OTHER_USER_STATUS_UPDATE: 1802,
    CID_OTHER_USER_CNT_UPDATE: 1803,
    CID_OTHER_SERVER_KICK_USER: 1805,
    CID_OTHER_LOGIN_STATUS_NOTIFY: 1806,
    CID_OTHER_PUSH_TO_USER_REQ: 1807,
    CID_OTHER_PUSH_TO_USER_RSP: 1808,
    CID_OTHER_GET_SHIELD_REQ: 1809,
    CID_OTHER_GET_SHIELD_RSP: 1810,
    CID_OTHER_FILE_TRANSFER_REQ: 1841,
    CID_OTHER_FILE_TRANSFER_RSP: 1842
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.ResultType = {
    REFUSE_REASON_NONE: 0,
    REFUSE_REASON_NO_MSG_SERVER: 1,
    REFUSE_REASON_MSG_SERVER_FULL: 2,
    REFUSE_REASON_NO_IM_PERSISTENCE_SERVER: 3,
    REFUSE_REASON_NO_MSG_LOAD_BALANCE_SERVER: 4,
    REFUSE_REASON_NO_ROUTE_SERVER: 5,
    REFUSE_REASON_DB_VALIDATE_FAILED: 6,
    REFUSE_REASON_VERSION_TOO_OLD: 7,
    REFUSE_REASON_TOKEN_EXPIRED: 8,
    REFUSE_REASON_TOKEN_INVALID: 9,
    REFUSE_REASON_TOKEN_REPLAY: 10,
    REFUSE_REASON_TOKEN_CLAIM_MISMATCH: 11,
    REFUSE_REASON_USER_NOT_FOUND: 12,
    REFUSE_REASON_USER_DISABLED: 13,
    REFUSE_REASON_DEVICE_MISMATCH: 14
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.KickReasonType = {
    KICK_REASON_NONE: 0,
    KICK_REASON_DUPLICATE_USER: 1,
    KICK_REASON_MOBILE_KICK: 2
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.OnlineListType = {
    ONLINE_LIST_TYPE_NONE: 0,
    ONLINE_LIST_TYPE_FRIEND_LIST: 1
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.UserStatType = {
    USER_STATUS_NONE: 0,
    USER_STATUS_ONLINE: 1,
    USER_STATUS_OFFLINE: 2,
    USER_STATUS_LEAVE: 3
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.SessionType = {
    SESSION_TYPE_NONE: 0,
    SESSION_TYPE_SINGLE: 1,
    SESSION_TYPE_GROUP: 2
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.MsgType = {
    MSG_TYPE_NONE: 0,
    MSG_TYPE_SINGLE_TEXT: 1,
    MSG_TYPE_SINGLE_AUDIO: 2,
    MSG_TYPE_SINGLE_FILE: 3,
    MSG_TYPE_SINGLE_CALL: 4,
    MSG_TYPE_GROUP_TEXT: 17,
    MSG_TYPE_GROUP_AUDIO: 18,
    MSG_TYPE_GROUP_CALL: 19
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.ClientType = {
    CLIENT_TYPE_NONE: 0,
    CLIENT_TYPE_WEB: 1,
    CLIENT_TYPE_ANDROID: 2,
    CLIENT_TYPE_IOS: 3,
    CLIENT_TYPE_WINDOWS: 4,
    CLIENT_TYPE_MAC: 5,
    CLIENT_TYPE_LINUX: 6
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.GroupType = {
    GROUP_TYPE_NONE: 0,
    GROUP_TYPE_NORMAL: 1,
    GROUP_TYPE_TMP: 2
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.GroupModifyType = {
    GROUP_MODIFY_NONE: 0,
    GROUP_MODIFY_TYPE_ADD: 1,
    GROUP_MODIFY_TYPE_DEL: 2
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.XFileType = {
    FILE_TYPE_NONE: 0,
    FILE_TYPE_ONLINE: 1,
    FILE_TYPE_OFFLINE: 2
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.ClientFileState = {
    CLIENT_FILE_PEER_READY: 0,
    CLIENT_FILE_CANCEL: 1,
    CLIENT_FILE_REFUSE: 2,
    CLIENT_FILE_DONE: 3
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.ClientFileRole = {
    CLIENT_REALTIME_NONE: 0,
    CLIENT_REALTIME_SENDER: 1,
    CLIENT_REALTIME_RECVER: 2,
    CLIENT_OFFLINE_UPLOAD: 3,
    CLIENT_OFFLINE_DOWNLOAD: 4
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.FileServerError = {
    FILE_SERVER_ERRNO_OK: 0,
    FILE_SERVER_ERRNO_CREATE_TASK_ID_ERROR: 1,
    FILE_SERVER_ERRNO_CREATE_TASK_ERROR: 2,
    FILE_SERVER_ERRNO_LOGIN_INVALID_TOKEN: 3,
    FILE_SERVER_ERRNO_INVALID_USER_FOR_TASK: 4,
    FILE_SERVER_ERRNO_PULL_DATA_WITH_INVALID_TASK_ID: 5,
    FILE_SERVER_ERRNO_PULL_DATA_ILLIEAGE_USER: 6,
    FILE_SERVER_ERRNO_PULL_DATA_MKDIR_ERROR: 7,
    FILE_SERVER_ERRNO_PULL_DATA_OPEN_FILE_ERROR: 8,
    FILE_SERVER_ERRNO_PULL_DATA_READ_FILE_HEADER_ERROR: 9,
    FILE_SERVER_ERRNO_PULL_DATA_ALLOC_MEM_ERROR: 10,
    FILE_SERVER_ERRNO_PULL_DATA_SEEK_OFFSET_ERROR: 11,
    FILE_SERVER_ERRNO_PULL_DATA_FINISHED: 12
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.SessionStatusType = {
    SESSION_STATUS_OK: 0,
    SESSION_STATUS_DELETE: 1
};
/**
 * @enum {number}
 */ proto.IM.BaseDefine.DepartmentStatusType = {
    DEPT_STATUS_OK: 0,
    DEPT_STATUS_DELETE: 1
};
goog.object.extend(exports, proto.IM.BaseDefine);

})();

export default module.exports;
